import { useEffect, FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'

import { Loading } from 'components/UI'
import { setLoggedIn } from 'store/actions/auth'

const HandleTransfer: FC = () => {
  const dispatch = useDispatch()
  const { token } = useParams<{ token?: string }>()
  const history = useHistory()
  const { isAuthenticated } = useSelector((state: MStore.RootState) => state.auth)

  useEffect(() => {
    if (token) {
      dispatch(setLoggedIn(token))
    }
  }, [token, dispatch])

  useEffect(() => {
    if (isAuthenticated) history.push('/my/home')
  }, [isAuthenticated, history])

  return <Loading />
}

export default HandleTransfer
